"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _noop = _interopRequireDefault(require("lodash/noop"));
var _poller = _interopRequireDefault(require("./poller"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var pollerInst = null;
function onPoll(context) {
  context.service.getExportTask();
}
function getExportPoller(context) {
  if (pollerInst !== null) {
    return pollerInst;
  }
  pollerInst = new _poller.default(context, 3000, _noop.default, onPoll);
  return pollerInst;
}
var _default = getExportPoller;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(pollerInst, "pollerInst", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/export-poller.js");
  reactHotLoader.register(onPoll, "onPoll", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/export-poller.js");
  reactHotLoader.register(getExportPoller, "getExportPoller", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/export-poller.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/export-poller.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJwb2xsZXJJbnN0Iiwib25Qb2xsIiwiY29udGV4dCIsInNlcnZpY2UiLCJnZXRFeHBvcnRUYXNrIiwiZ2V0RXhwb3J0UG9sbGVyIiwiUG9sbGVyIiwibm9vcCJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tb24vZXhwb3J0LXBvbGxlci5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgbm9vcCBmcm9tICdsb2Rhc2gvbm9vcCc7XG5pbXBvcnQgUG9sbGVyIGZyb20gJy4vcG9sbGVyJztcblxubGV0IHBvbGxlckluc3QgPSBudWxsO1xuXG5mdW5jdGlvbiBvblBvbGwoY29udGV4dCkge1xuXHRjb250ZXh0LnNlcnZpY2UuZ2V0RXhwb3J0VGFzaygpO1xufVxuXG5mdW5jdGlvbiBnZXRFeHBvcnRQb2xsZXIoY29udGV4dCkge1xuXHRpZiAocG9sbGVySW5zdCAhPT0gbnVsbCkge1xuXHRcdHJldHVybiBwb2xsZXJJbnN0O1xuXHR9XG5cblx0cG9sbGVySW5zdCA9IG5ldyBQb2xsZXIoY29udGV4dCwgMzAwMCwgbm9vcCwgb25Qb2xsKTtcblxuXHRyZXR1cm4gcG9sbGVySW5zdDtcbn1cblxuZXhwb3J0IGRlZmF1bHQgZ2V0RXhwb3J0UG9sbGVyO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFDQTtBQUE4QjtFQUFBO0VBQUE7QUFBQTtBQUFBO0VBQUE7QUFBQTtBQUU5QixJQUFJQSxVQUFVLEdBQUcsSUFBSTtBQUVyQixTQUFTQyxNQUFNLENBQUNDLE9BQU8sRUFBRTtFQUN4QkEsT0FBTyxDQUFDQyxPQUFPLENBQUNDLGFBQWEsRUFBRTtBQUNoQztBQUVBLFNBQVNDLGVBQWUsQ0FBQ0gsT0FBTyxFQUFFO0VBQ2pDLElBQUlGLFVBQVUsS0FBSyxJQUFJLEVBQUU7SUFDeEIsT0FBT0EsVUFBVTtFQUNsQjtFQUVBQSxVQUFVLEdBQUcsSUFBSU0sZUFBTSxDQUFDSixPQUFPLEVBQUUsSUFBSSxFQUFFSyxhQUFJLEVBQUVOLE1BQU0sQ0FBQztFQUVwRCxPQUFPRCxVQUFVO0FBQ2xCO0FBQUMsZUFFY0ssZUFBZTtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtJQUFBO0VBQUE7RUFBQSx3QkFoQjFCTCxVQUFVO0VBQUEsd0JBRUxDLE1BQU07RUFBQSx3QkFJTkksZUFBZTtFQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtBQUFBIn0=